import { QueryClient } from '@tanstack/react-query';
import { rootStore } from '#/stores';
import clientConfig from '@jucy-nakuru/config/clientConfig';
import '@jucy-ui/appearance';
import '@jucy-ui/common';
import { LicenseInfo } from '@mui/x-license-pro';
import '../services/firebaseClient';
import './initDatadog';
import './wdyr';

LicenseInfo.setLicenseKey('a54786f8648eec73fcc8176f0644a034Tz0xMjgxMjksRT0xODA3NzQ3MTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            gcTime: 60 * 1000,
        },
    },
});
globalThis.jucyConfig.rentalsApiBaseUrl = clientConfig.rentalsApi.baseUrl;
globalThis.jucyConfig.rentalsApiMiddleware = [
    ...(globalThis.jucyConfig.rentalsApiMiddleware || []),
    {
        pre: async (context) => {
            const token = rootStore?.authStore?.accessToken;
            if (!token) {
                return context;
            }

            return {
                url: context.url,
                init: {
                    ...context.init,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        ...context.init.headers,
                    },
                },
            };
        },
    },
];
